import { AreaInterest } from "../../classes";

const AreaInterestModule = {
  namespaced: true,
  state: {
    areaInterests: [],
    areaInterest: null
  },
  actions: {
    async getAreaInterests({ commit, rootGetters }, payload) {
      try {
        const marketId = payload && payload.marketId ? payload.marketId : rootGetters["markets/getMarketId"];
        const data = await AreaInterest.getAreaInterests({ marketId });
        commit("setAreaInterests", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async getAreaInterest({ commit }, payload) {
      try {
        const data = await AreaInterest.getAreaInterest(payload);
        commit("setAreaInterest", data);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async createAreaInterest({ commit, dispatch }, payload) {
      try {
        const data = await AreaInterest.createAreaInterest(payload);
        // dispatch
        return data;
      } catch (error) {
        throw error;
      }
    },
    async updateAreaInterest({ commit, dispatch }, payload) {
      try {
        const data = await AreaInterest.updateAreaInterest(payload);
        // dispatch
        return data;
      } catch (error) {
        throw error;
      }
    },
    async updateAreaInterestStatus({ commit, dispatch, rootGetters }, payload) {
      try {
        const data = await AreaInterest.updateAreaInterestStatus(payload);
        // dispatch markets/getMarket
        await dispatch(
          "markets/getMarketArea",
          { id: rootGetters["markets/getMarketId"] },
          { root: true }
        );
        return data;
      } catch (error) {
        throw error;
      }
    },
    async approveAreaInterest({ commit, dispatch }, payload) {
      try {
        const data = await AreaInterest.approveAreaInterest(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async rejectAreaInterest({ commit, dispatch }, payload) {
      try {
        const data = await AreaInterest.rejectAreaInterest(payload);
        return data;
      } catch (error) {
        throw error;
      }
    },
    async getAreaInterestByArea({ commit }, payload) {
      try {
        const data = await AreaInterest.getAreaInterestByArea(payload);
        commit("setAreaInterests", data);
        return data;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    areaInterests: state => state.areaInterests,
    areaInterest: state => state.areaInterest
  },
  mutations: {
    setAreaInterests(state, areaInterests) {
      state.areaInterests = areaInterests;
    },
    setAreaInterest(state, areaInterest) {
      state.areaInterest = areaInterest;
    }
  }
};
export default AreaInterestModule;
